module.exports = __webpack_public_path__ + "media/images/faq-hero-99b4d5b46a89f7a67bff799d2c43490a.jpg";